import { render, staticRenderFns } from "./GeminiDraftTranslation.vue?vue&type=template&id=02983c58&scoped=true"
import script from "./GeminiDraftTranslation.vue?vue&type=script&lang=js"
export * from "./GeminiDraftTranslation.vue?vue&type=script&lang=js"
import style0 from "./GeminiDraftTranslation.vue?vue&type=style&index=0&id=02983c58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02983c58",
  null
  
)

export default component.exports